import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  logo: {
    margin: '40px 0 !important',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: { border: '1px solid var(--grayLv4) !important' },
  title: {
    width: '100%',
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    width: '100%',
    textAlign: 'center',
  },
}));

export default useStyles;
